<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择技能"
      width="900px"
      top="5vh">
    <vm-table
        ref="vmTable"
        :columns-btn-show="false"
        :filter.sync="filter"
        module="basic"
        url="skills">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="技能编号：">
            <el-input v-model.trim="filter.skillNo" placeholder="请输入技能编号" clearable/>
          </vm-search>
          <vm-search label="技能名称：">
            <el-input v-model.trim="filter.skillName" placeholder="请输入技能名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="skillNo" align="center" label="技能编号" width="150"/>
      <el-table-column prop="skillName" align="left" label="技能名称"/>
      <el-table-column label="操作" align="center" width="80px" prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "SkillSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          skillNo: "",
          skillName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
